<template>
  <div>
    <div class="container">
      <button class="button is-link no_print" @click="print">印刷プレビュー</button>
      <PrintElement ref="print" :tasks_data="tasks_data" :photo="photos" />
    </div>
  </div>
</template>

<script>
import PrintElement from "./print";
import { mapGetters, mapState } from "vuex"

export default {
  data: function(){
    return {
      showModal: false,
    }
  },
  computed:{
    ...mapGetters({
      tasks_data: 'task/task_logs',
      photos: 'task/photos'
    }),
    ...mapState({
      apiStatus: state => state.task.apiStatus,
    })
  },
  components: {
    PrintElement,
  },
  mounted(){
    this.getTask()
  },
  methods:{
    print() {
      window.print();
    },
    async getTask(){
      await this.$store.dispatch('task/getTask', { key: this.$route.params.q})
      if(this.apiStatus){
        this.$refs.print.initMap()
      }
    },
  }
}
</script>

<style scoped>
  button {
    margin: 0.75rem;
  }
</style>